(function (angular) {
    'use strict';

    angular.module('appMessaging')

        /**
         *
         */
        .factory('pushService',
            ['$http', '$q', 'jwtService', 'portalConfig',
                function ($http, $q, jwtService, portalConfig) {

                    const urlBase = portalConfig.urlBase;

                    var fac = {
                        getPushConfig: getPushConfig,
                        setFCMPushConfig: setFCMPushConfig,
                        delPushFCMConfig: delPushFCMConfig,
                        setAPNSPushConfig: setAPNSPushConfig,
                        setAPNSTokenConfig: setAPNSTokenConfig,
                        delPushAPNSConfig: delPushAPNSConfig,
                        delPushAPNSTokenConfig: delPushAPNSTokenConfig
                    };

                    return fac;

                    /**
                     * @param {string} id - the api space Id
                     */
                    function getPushConfig(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/push")
                            .then(getPushConfigComplete)
                            .catch(getPushConfigFailed);

                        function getPushConfigComplete(response) {
                            return response.data;
                        }

                        function getPushConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }
                    /**
                     * @param {string} id - the api space Id
                     * @param {string} name - fcm name
                     * @param {string} serverKey - fcm server key
                     * @param {file} privateKeyFile - fcm private key
                     */
                    function setFCMPushConfig(id, name, serverKey, privateKeyFile) {
                        const basePath = urlBase + '/apispaces/' + id + '/push/fcm/';
                        const path = basePath + (privateKeyFile ? 'v1/' : '') + name;

                        if (privateKeyFile) {
                            return sendPrivateKeyRequest(path, privateKeyFile);
                        } else {
                            return sendServerKeyRequest(path, serverKey);
                        }

                        function sendPrivateKeyRequest(path, privateKeyFile) {
                            const fd = new FormData();
                            fd.append('key', privateKeyFile);

                            return $http.put(path, fd, {
                                transformRequest: angular.identity,
                                headers: {
                                    'Content-Type': undefined,
                                },
                            })
                                .then(setFCMPushConfigComplete)
                                .catch(setFCMPushConfigFailed);
                        }

                        function sendServerKeyRequest(path, serverKey) {
                            const request = { serverKey };

                            return $http.put(path, request)
                                .then(setFCMPushConfigComplete)
                                .catch(setFCMPushConfigFailed);
                        }

                        function setFCMPushConfigComplete(response) {
                            return response.data;
                        }

                        function setFCMPushConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * @param {string} id - the api space Id
                     * @param {string} name - fcm name
                     */
                    function delPushFCMConfig(id, name) {
                        return $http.delete(urlBase + "/apispaces/" + id + "/push/fcm/" + name)
                            .then(setFCMPushConfigComplete)
                            .catch(setFCMPushConfigFailed);

                        function setFCMPushConfigComplete(response) {
                            return response.data;
                        }

                        function setFCMPushConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * @param {string} id - the api space Id
                     * @param {file} cert - app certificate
                     * @param {string} password - password to app certificate
                     */
                    function setAPNSPushConfig(id, data, password) {
                        var fd = new FormData();
                        fd.append("cert", data);
                        fd.append("password", password);
                        return $http.put(urlBase + "/apispaces/" + id + "/push/apns", fd, {
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            }
                        })
                            .then(setAPNSPushConfigComplete)
                            .catch(setAPNSPushConfigFailed);

                        function setAPNSPushConfigComplete(response) {
                            return response.data;
                        }

                        function setAPNSPushConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }


                    }

                    /**
                     * @param {string} id - the api space Id
                     * @param {file} token - token
                     * @param {string} keyId - keyId
                     * * @param {string} teamId - teamId
                     */
                    function setAPNSTokenConfig(id, data, keyId, teamId) {
                        var fd = new FormData();
                        fd.append("key", data);
                        fd.append("keyId", keyId);
                        fd.append("teamId", teamId);
                        return $http.put(urlBase + "/apispaces/" + id + "/push/apnstoken", fd, {
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            }
                        })
                            .then(setAPNSTokenConfigComplete)
                            .catch(setAPNSTokenConfigFailed);

                        function setAPNSTokenConfigComplete(response) {
                            return response.data;
                        }

                        function setAPNSTokenConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }


                    /**
                     * @param {string} id - the api space Id
                     * @param {string} bundleId - apns bundle id
                     * @param {string} type - production or development version
                     */
                    function delPushAPNSConfig(id, bundleId, type) {

                        return $http.delete(urlBase + "/apispaces/" + id + "/push/apns/" + bundleId + "/" + type)
                            .then(setAPNSPushConfigComplete)
                            .catch(setAPNSPushConfigFailed);

                        function setAPNSPushConfigComplete(response) {
                            return response.data;
                        }

                        function setAPNSPushConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }


                    }

                    /**
                     * @param {string} id - the api space Id
                     */
                    function delPushAPNSTokenConfig(id, bundleId, type) {

                        return $http.delete(urlBase + "/apispaces/" + id + "/push/apnstoken")
                            .then(function (response) {
                                return response.data;
                            })
                            .catch(function (error) {
                                console.error(JSON.stringify(error));
                                return $q.reject(error);
                            });
                    }


                }]);

})(window.angular);
